import { render, staticRenderFns } from "./ListProdutos.vue?vue&type=template&id=6de07c77&scoped=true&"
import script from "./ListProdutos.vue?vue&type=script&lang=js&"
export * from "./ListProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de07c77",
  null
  
)

export default component.exports